import {
    Autocomplete,
    Button,
    Checkbox,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import { makeFormStyles } from 'forms/styles';
import { Draggable } from 'react-beautiful-dnd';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdDelete, MdDragHandle } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { MultiSelectDoneButton } from 'GeminiViewerComponent/components/MultiSelectDoneButton';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { FormTextField } from 'components/TextField';

const HotspotPairsTargetNode = ({
    option,
    selectOptions,
    idx,
    nodes,
    node,
    values,
    setFieldValue,
    handleRemove,
    ...otherProps
}) => {
    let currentCombinations =
        option.options_required?.length > 0
            ? option.options_required.map((opt) => {
                  return selectOptions.find((sel) => sel.option_text === opt.option_text);
              })
            : [];
    currentCombinations = currentCombinations.filter((opt) => opt !== undefined);
    const theme = useSelector(selectDefaultTheme);
    nodes = nodes.filter((nd) => nd.id !== node.id);
    const commonFormStyles = makeFormStyles(theme);

    return (
        <Draggable
            key={'hotspot_pairs_target_draggable_' + idx}
            draggableId={String('hotspot_pairs_target_draggable_' + idx)}
            index={idx}
        >
            {(provided) => (
                <div ref={provided.innerRef} {...provided.draggableProps}>
                    <Grid
                        container
                        key={'hotspot_pairs_target_' + idx}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '6px',
                        }}
                        {...otherProps}
                    >
                        <Grid
                            display={'flex'}
                            alignItems="center"
                            justifyContent={'center'}
                            item
                            xs={12}
                            sm={12}
                            md={1}
                            lg={1}
                            {...provided.dragHandleProps}
                        >
                            <MdDragHandle className="react-icon" />
                        </Grid>
                        <Grid display={'flex'} alignItems="center" item xs={12} sm={12} md={4} lg={4}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    key={`Image-Pairs-Target-${idx}`}
                                    limitTags={3}
                                    multiple
                                    variant="outline"
                                    id={`Image-pair-options-${idx}`}
                                    disableCloseOnSelect
                                    options={selectOptions}
                                    value={currentCombinations}
                                    clearIcon={<MdDelete fontSize="18" />}
                                    onChange={(_, newInputValue) => {
                                        let currImagePairs = [...values.hotspot_target_combinations];
                                        currImagePairs[idx] = {
                                            ...values.hotspot_target_combinations[idx],
                                            options_required: newInputValue,
                                        };
                                        setFieldValue('hotspot_target_combinations', currImagePairs);
                                    }}
                                    style={{ width: '100%' }}
                                    getOptionLabel={(option) => option?.item?.display_name}
                                    renderOption={(props, option, { selected }) => {
                                        return (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={<MdCheckBoxOutlineBlank className="react-icon" />}
                                                    checkedIcon={<MdCheckBox className="react-icon" />}
                                                    style={{
                                                        marginRight: 8,
                                                    }}
                                                    checked={selected}
                                                />
                                                {option?.item?.display_name}
                                            </li>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Option Pair"
                                            placeholder="Option Pair"
                                        />
                                    )}
                                    PaperComponent={MultiSelectDoneButton}
                                />
                            </FormControl>
                        </Grid>
                        <Grid display={'flex'} alignItems="center" item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <InputLabel id="target-node-id">Target Node</InputLabel>
                                <Select
                                    className={commonFormStyles.materialSelect}
                                    style={{
                                        margin: '0',
                                    }}
                                    labelId="target-node-id"
                                    margin="dense"
                                    id="target_node_id"
                                    label="Target Node"
                                    placeholder="Target Node"
                                    name={`hotspot_target_combinations[${idx}].target_node_id`}
                                    value={option?.action?.id}
                                    onChange={(e) => {
                                        let currImagePairs = [...values.hotspot_target_combinations];
                                        currImagePairs[idx] = {
                                            ...values.hotspot_target_combinations[idx],
                                            action: {
                                                ...values.hotspot_target_combinations[idx].action,
                                                id: e.target.value,
                                            },
                                        };
                                        setFieldValue('hotspot_target_combinations', currImagePairs);
                                    }}
                                >
                                    <MenuItem key={'next'} value={'next'}>
                                        Next
                                    </MenuItem>
                                    <MenuItem key={'back'} value={'back'}>
                                        Back
                                    </MenuItem>
                                    {nodes?.length > 0 &&
                                        nodes.map((nd) => (
                                            <MenuItem key={nd?.id} value={nd?.id}>
                                                {nd?.title} - #{nd?.id}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid display={'flex'} alignItems="center" item xs={12} sm={12} md={2} lg={2}>
                            <FormControl fullWidth>
                                <FormTextField
                                    label="Answer Value"
                                    placeholder="Answer Value"
                                    name={`hotspot_target_combinations[${idx}].answer_value`}
                                    onChange={(e) => {
                                        let currOptions = [...values.hotspot_target_combinations];
                                        currOptions[idx] = {
                                            ...values.hotspot_target_combinations[idx],
                                            answer_value: e.target.value,
                                        };
                                        setFieldValue(`hotspot_target_combinations`, currOptions);
                                    }}
                                    {...otherProps}
                                />
                            </FormControl>
                        </Grid>
                        <Grid display={'flex'} alignItems="center" item xs={12} sm={12} md={1} lg={1}>
                            <FormControl fullWidth>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        handleRemove(idx);
                                    }}
                                >
                                    Remove
                                </Button>{' '}
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            )}
        </Draggable>
    );
};

export default HotspotPairsTargetNode;
